// src/pages/Home.tsx

import React, { useState, useEffect } from "react";
import { useUnifiedUser } from "../context/UserContext";
import { usePremiumStatus } from "../context/PremiumStatusContext";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardActions,
  Container,
  Grid,
  Paper,
  Typography,
  styled,
  Dialog,
} from "@mui/material";
import SubscriptionPlans from "../components/seagoplancard/SubscriptionPlans";
import { useLocation } from "react-router-dom";
import SuccessAlert from "../components/SuccessAlert/SuccessAlert";

const StyledContainer = styled(Container)(({ theme }) => ({
  marginTop: theme.spacing(8),
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "transparent",
}));

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(12),
  height: theme.spacing(12),
}));

const HomePage: React.FC = () => {
  const { signOut, user } = useUnifiedUser();
  const {
    isSubscribedStripe,
    currentRoleStripe,
    subscriptionTypeStripe,
    isLoading,
  } = usePremiumStatus();
  const location = useLocation();

  // State variables for managing the SuccessAlert modal
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [secondMessage, setSecondMessage] = useState(false);

  // Effect to check for 'status' query parameter and display the alert accordingly
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const status = queryParams.get("status");
    console.log(isSubscribedStripe);
    if (status === "success" && isSubscribedStripe) {
      setAlertMessage("Your subscription was successful!");
      setSecondMessage(true);
      setShowSuccessAlert(true);
    }
    //  else if (status === "cancel") {
    //   setAlertMessage("Your subscription was cancelled.");
    //   setShowSuccessAlert(true);
    // }
  }, [location.search, isSubscribedStripe]);

  // Handler to close the SuccessAlert modal and remove the query parameter from the URL
  const handleCloseSuccessAlert = () => {
    setShowSuccessAlert(false);
    // Remove the 'status' query parameter from the URL without reloading the page
    const url = new URL(window.location.href);
    url.searchParams.delete("status");
    window.history.replaceState({}, document.title, url.toString());
  };

  // Handler for logging out the user
  const handleLogout = () => {
    signOut();
  };

  return (
    <StyledContainer maxWidth="md">
      <Grid container spacing={4}>
        {user && (
          <>
            {/* User Information Card */}
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  <Box display="flex" justifyContent="center" mb={2}>
                    <StyledAvatar
                      alt={user.username || "User"}
                      src={user.profilePhotoUrl || ""}
                    />
                  </Box>
                  <Typography variant="h5" align="center" gutterBottom>
                    Welcome, {user.username || "User"}
                  </Typography>
                  <Typography
                    variant="body2"
                    align="center"
                    color="textSecondary"
                  >
                    {user.email}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Box display="flex" justifyContent="center" width="100%">
                    <Button
                      variant="contained"
                      color="error"
                      onClick={handleLogout}
                    >
                      Logout
                    </Button>
                  </Box>
                </CardActions>
              </Card>
            </Grid>

            {/* Premium Status Card */}
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  <Typography variant="h6" align="center" gutterBottom>
                    Premium Status
                  </Typography>
                  <Typography
                    variant="body2"
                    align="center"
                    color="textSecondary"
                  >
                    {isSubscribedStripe
                      ? `You are a ${currentRoleStripe} subscriber on a ${subscriptionTypeStripe} plan`
                      : "You are a visitor with no subscription plan"}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </>
        )}

        {/* Subscription Plans Section */}
      </Grid>
      <Grid item xs={12} style={{ marginTop: "-16px" }}>
        <SubscriptionPlans />
      </Grid>
      {/* SuccessAlert Modal */}
      <Dialog
        open={showSuccessAlert}
        onClose={handleCloseSuccessAlert}
        aria-labelledby="success-alert-title"
        aria-describedby="success-alert-description"
      >
        <SuccessAlert
          message={alertMessage}
          secondMessage={secondMessage}
          onClose={handleCloseSuccessAlert}
        />
      </Dialog>
    </StyledContainer>
  );
};

export default HomePage;
